var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tag-selector-tree" },
    _vm._l(_vm.tagTypes, function(tagType) {
      return _c(
        "div",
        { key: tagType, staticClass: "tag-selector-tree-type" },
        [
          _c(
            "span",
            {
              staticClass: "tag-type-name",
              class: { active: _vm.expandCollapseTypesTree[tagType] },
              on: {
                click: function($event) {
                  return _vm.toggleExpandType(tagType)
                }
              }
            },
            [_vm._v("\n      " + _vm._s(tagType) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.forSearch || _vm.expandCollapseTypesTree[tagType],
                  expression: "forSearch || expandCollapseTypesTree[tagType]"
                }
              ],
              staticClass: "tag-selector-tree-name list-unstyled"
            },
            _vm._l(_vm.sortedTagsByType[tagType].tags, function(tag, index) {
              return _c("li", { key: index, staticClass: "tag-name" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.$emit("selectTag", tag)
                      }
                    }
                  },
                  [
                    tag.displayName
                      ? _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(tag.displayName) +
                              "\n          "
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("camelCaseFormat")(tag.tagName)) +
                              "\n          "
                          )
                        ])
                  ]
                )
              ])
            }),
            0
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }